import ServiceExec from '@/common/utils/ServiceExec';
import { premium } from '@/common/service/apiList';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

export default {
  getPremiumPointList: async function({ commit, getters, state }, menu) {
    const condition = getters['getCondition'];
    if (condition.page > state.pageInfo.endPage) return;
    const { userNo } = store.getters['user/getUserData'];
    condition.userNo = userNo;
    condition.searchType = menu;
    const { data, status } = await ServiceExec.get(premium.getPremiumPointList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
  },
  getPoint: async ({}) => {
    const { userNo } = store.getters['user/getUserData'];
    // 261029 JUMP-USER-14: 비로그인이 햄버거 '프리미엄 포인트'로 /more/premium 에 들어오면 URL_GUARD 는 안내 창만 띄우고 화면은 열린다.
    //   userNo 없이 부르면 ServiceExec 가 /point/undefined 를 막고 응답 없이(undefined) 돌려줘 아래 구조분해가 터졌다.
    if (isEmpty(userNo)) return false;
    const { data, status } = await ServiceExec.get(premium.getPoint(userNo));
    if (ServiceExec.status.OK !== status) return false;
    store.commit('user/setUserPoint', data);
    return data;
  }
};
